// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-generic{display:block;margin:0 0 40px}.title-generic h1{font-size:34px;font-weight:700;line-height:normal;display:block;margin:0 0 10px}.title-generic label{font-size:18px;font-weight:300;line-height:1.39;display:block;margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
